module.exports = __webpack_public_path__ + "static/media/suitcase.66690fda.svg";